<template>
  <div class="qualification-enterprise">
    <div class="qualification-title">企业资质</div>
    <div class="qualification-description">基于行业最佳实践的业务标准，实现合理高效的管理方式</div>
    <div class="qualification-content">
      <div class="content-top">
        <div v-for="(item, k) in contentList1" :key="k" class="item-div">
          <img :src="item.img" alt="" @click="clickHandle(item)">
          <span>{{ item.title }}</span>
        </div>
      </div>
      <div class="content-bottom">
        <div v-for="(item, k) in contentList2" :key="k" class="item-div">
          <img :src="item.img" alt="" @click="clickHandle(item)">
          <span>{{ item.title }}</span>
        </div>
      </div>
    </div>

    <div class="dialog__wrapper" v-if="isShow" @click="dialogClick">
      <div class="dialog-content">
          <img class="img1 btn-img" v-lazy="btn1" alt=""  @click.stop="triggerHandle(-1)">
          <img class="img2 btn-img" v-lazy="btn2" alt="" @click.stop="triggerHandle(1)">
          <img v-lazy="clickInfo.img" class="img-content" alt="" @click.stop>
      </div>
    </div>
  </div>
</template>

<script>
import a1 from '@/assets/images/qualifications/a1.png'
import a2 from '@/assets/images/qualifications/a2.png'
import a3 from '@/assets/images/qualifications/a3.png'
import a4 from '@/assets/images/qualifications/a4.png'
import a5 from '@/assets/images/qualifications/a5.png'
import a6 from '@/assets/images/qualifications/a6.png'
import a7 from '@/assets/images/qualifications/a7.png'
import a8 from '@/assets/images/qualifications/a8.png'
import a9 from '@/assets/images/qualifications/a9.png'

import btn1 from '@/assets/images/btn1.png'
import btn2 from '@/assets/images/btn2.png'

export default {
  data() {
    return {
      isShow: false,
      btn1,
      btn2,
      numVal: 1,
      contentList1: [
        {
          img: a1,
          title: '高新技术企业',
          num: 1
        },
        {
          img: a2,
          title: 'CMMI5',
          num: 2
        },
        {
          img: a3,
          title: 'CS2级证书',
          num: 3
        },
        {
          img: a4,
          title: 'ITSS证书',
          num: 4
        }
      ],
      contentList2: [
        {
          img: a5,
          title: 'ISO27001',
          num: 5
        },
        {
          img: a6,
          title: 'ISO9001',
          num: 6
        },
        {
          img: a7,
          title: 'ISO20000-1',
          num: 7
        },
        {
          img: a8,
          title: 'ISO45001',
          num: 8
        },
        {
          img: a9,
          title: 'ISO14001',
          num: 9
        }
      ]
    }
  },
  computed: {
    clickInfo({ contentList1, contentList2, numVal  }) {
      const allArr = [...contentList1, ...contentList2]
      return allArr.filter(item => item.num === numVal )[0]
    }
  },
  watch: {
  
  },
  mounted() {
  },
  destroyed() {
  },
  methods: {
    dialogClick() {
      this.isShow = false
    },
    clickHandle(item) {
      this.numVal = item.num
      this.isShow = true
    },
    triggerHandle(val) {
      const valNum  = this.numVal + val
      if(valNum === 0) {
        this.numVal = 9
      } else if(valNum === 10) {
        this.numVal = 1
      } else {
        this.numVal = valNum
      }
    }
   
  }
}
</script>

<style lang="scss" scoped>
.qualification-enterprise {
  background-color: #f0f2f5;
  .qualification-title {
    padding: 12rem 0 2.4rem;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 4rem;
    color: #333333;
    line-height: 4rem;
    text-align: center;
    font-style: normal;
    text-transform: uppercase;
  }
  .qualification-description {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 1.8rem;
    color: #666A77;
    line-height: 1.8rem;
    text-align: center;
    font-style: normal;
    margin-bottom: 6.7rem;
  }
  .qualification-content {
    padding: 0 22rem 3rem;
    .content-top,
    .content-bottom {
      width: 100%;
      display: flex;
      padding-bottom: 9rem;
      .item-div {
        flex: 1;
        text-align: center;
        margin: 0 2rem;
        &:first-child {
          margin-left: 0;
        }
        &:last-child {
          margin-right: 0;
        }
        img {
          width: 100%;
          cursor: pointer;
          margin-bottom: 4rem;
        }
        span {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 2.4rem;
          color: #333333;
          line-height: 2.6rem;
          font-style: normal;
        }
      }
    }

    .content-top {
      .item-div {
        img {
          height: 26rem;
        }
      }
    }
    .content-bottom {
      .item-div {
        img {
          height: 37.5rem;
        }
      }
    }

  }

  .dialog__wrapper {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    z-index: 2017;
    background: rgba(0, 0, 0, .4);
    padding: 0rem 45rem 0;
    .dialog-content {
      position: relative;
      width: 100%;
      height: 90vh;
      text-align: center;
      .btn-img {
        width: 5.4rem;
        height: 5.4rem;
        position: absolute;
        transform: translateY(-50%);
        top: 50%;
        border-radius: 50%;
        cursor: pointer;
      }
      .img1 {
        left: 0;
      }
      .img2 {
        right: 0;
      }
      .img-content {
        width: 60rem;
        position: absolute;
        transform: translate(-50%, -50%);
        top: 50%;
        left: 50%;

      }
    }
  }

}

@import "@/styles/mixins.scss";

@include mobile {
  .qualification-enterprise {
    display: none;
  }
}
</style>